<template>
  <div>
    <div class="selection-screen__body">
      <div class="selection-screen__success">
        <img
          class="selection-icon"
          :src="require('@/assets/hrVenue/add-candidate-succes.svg')"
        />
        <h3 class="selection-title">
          {{ resource["addCandidateModalBodyTitle"] }}
        </h3>
        <span>{{ resource["addCandidateModalBodyDesc"] }}</span>
      </div>
      <b-form-group>
        <b-form-radio-group
          v-model="selectionModalType"
          class="type-radio"
          name="radio-btn-stacked"
          buttons
          stacked
        >
          <b-form-radio value="one-by-one-modal">
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="radio-btn-info">
                <h3>{{ resource["addCandidateOnebyOne"] }}</h3>
              </div>
            </div>
          </b-form-radio>
          <b-form-radio value="excel-modal">
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="radio-btn-info">
                <h3>{{ resource["addCandidateExcel"] }}</h3>
              </div>
            </div>
          </b-form-radio>
          <b-form-radio value="ats-modal">
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="radio-btn-info">
                <h3>{{ resource["addCandidateAts"] }}</h3>
              </div>
            </div>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>
    <div class="selection-screen__footer">
      <b-button name="cancel" class="border-button-create" @click="hiddenModal">
        <span>{{ resource["addCandidateModalCancelBtn"] }}</span>
      </b-button>
      <b-button
        :disabled="!selectionModalType"
        name="next"
        class="bg-button gap-2 d-flex align-items-center"
        @click="selectModalType"
      >
        <span>{{ resource["addCandidateModalNextBtn"] }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalSelectionScreen',
  data() {
    return {
      selectionModalType: null,
    };
  },
  methods: {
    selectModalType() {
      if (this.selectionModalType !== null) {
        this.$emit('showAddCandidateModalHandler', this.selectionModalType);
      }
    },
    hiddenModal() {
      this.$emit('onHide');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.type-radio {
  width: 100%;
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.selection-title {
  max-width: 320px;
}

.selection-screen__body {
  ::v-deep .btn-group-toggle {
    .btn {
      width: 100% !important;
      height: auto !important;
      display: flex;
      padding: 24px 16px !important;
      align-items: center;
      gap: 12px;
      align-self: stretch;
      border-radius: 4px;
      border: 1px solid #e4e4e4;
      background: #fff;
      display: flex;
      margin-bottom: 0;
      height: auto;
      margin-right: 0;
      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        height: 124px;
        width: 100%;
      }

      &:focus {
        box-shadow: none;
      }

      &:hover {
        background: #fff6e5;
      }

      &.active {
        border: 1px solid #ff8d06;
        background: #fff6e5;
      }

      input[type="radio"] {
        position: initial;
        /* remove standard background appearance */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        /* create custom radiobutton appearance */
        display: inline-block;
        width: 16px;
        height: 16px;
        padding: 3px;
        /* background-color only for content */
        background-clip: content-box;
        border: 1px solid #353535;
        background-color: transparent;
        border-radius: 50%;
      }

      input[type="radio"]:checked {
        background-color: #ff8d06;
        border: 1px solid #ff8d06;
      }
    }
  }
  ::v-deep .focus {
    box-shadow: none !important;
  }
}

.radio-btn-info {
  h3 {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #353535;
  }

  p {
    color: #858585;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
  }
}
</style>
